import { collectionListQueryOptions } from '@/hooks/collections/use-collections';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function collectionsIndexLoader() {
  return {
    promises: queryClient.ensureQueryData(collectionListQueryOptions).catch(catchFetcherError),
  };
}
